import { useCallback } from 'react';
import type React from 'react';

import { usePageScrollPosition } from '#src/app/pages/petitionDetails/shared/hooks';
import type { WaypointCallbackArgs } from '#src/app/shared/components/layout/lazy';
import { Waypoint } from '#src/app/shared/components/scroll';

export const AfterMediaWaypoint: React.FC = () => {
	const { setAfterMedia } = usePageScrollPosition();

	const onPositionChange = useCallback(
		({ currentPosition }: WaypointCallbackArgs) => setAfterMedia(currentPosition === 'above'),
		[setAfterMedia],
	);

	// using onPositionChange so that it is triggered at hydration
	return <Waypoint onPositionChange={onPositionChange} />;
};
